import { createFileRoute } from "@tanstack/react-router";
import { Wallet } from "lucide-react";
import { z } from "zod";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { MyPayments } from "@/features/payments/modules/my-payments/my-payments";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/my-payments/")({
  loader: () => ({ crumb: m.my_payments_title() }),
  validateSearch: z.object({ tab: z.enum(["history", "subscriptions"]).optional().catch(undefined) }),
  component: MyPaymentsPage,
});

function MyPaymentsPage() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PageShell icon={Wallet} title={m.my_payments_title()} description={m.my_payments_description()}>
      <MyPayments tab={tab ?? "history"} onTabChange={(next) => void navigate({ search: { tab: next } })} />
    </PageShell>
  );
}
